export enum Routes {
  FleetServiceRouter = "*",
  ServiceSearchPageRouter = "/fleet/service/search",
}
